// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.checkbox-input-wrapper[data-v-0c1d7116] {
  position: relative;
}
.checkbox-input-mover[data-v-0c1d7116] {
  position: absolute;
  right: 0;
  top: 8px;
}
.price-label[data-v-0c1d7116] {
  background: none;
  bottom: 8px;
  left: 8px;
  pointer-events: none;
}
.obsolete-item[data-v-0c1d7116] {
  text-decoration: line-through;
}
.quantity-table[data-v-0c1d7116] .v-input {
  padding-top: 0;
  margin-top: 0;
}
.quantity-table[data-v-0c1d7116] {
  width: 100%;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
